import React from 'react';
import { Sparkles } from 'lucide-react';
export function MicroTranceSection() {
  return <section className="w-full bg-gradient-to-b from-teal-50 to-white py-16 px-4" data-id="element-167">
      <div className="max-w-4xl mx-auto text-center" data-id="element-168">
        <div className="flex items-center justify-center mb-8" data-id="element-169">
          <Sparkles size={32} className="text-teal-600 mr-3" data-id="element-170" />
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-171">
            Visualize Your New Life
          </h2>
        </div>
        <div className="bg-white rounded-lg shadow-lg p-8 mb-10" data-id="element-172">
          <p className="text-xl text-gray-700 italic mb-6" data-id="element-173">
            Close your eyes for a moment... And listen to your breathing.
          </p>
          <div className="space-y-6 text-left mb-8" data-id="element-174">
            <div className="p-4 border-l-4 border-teal-600 bg-teal-50" data-id="element-175">
              <p className="text-lg text-gray-700" data-id="element-176">
                Feel what it would be like to wake up with mental clarity. With
                a lighter body. Clean energy flowing... from within.
              </p>
            </div>
            <div className="p-4 border-l-4 border-teal-600 bg-teal-50" data-id="element-177">
              <p className="text-lg text-gray-700" data-id="element-178">
                Your doctor reviews your test results, looks up and says:
                "Whatever you're doing... keep it up."
              </p>
            </div>
            <div className="p-4 border-l-4 border-teal-600 bg-teal-50" data-id="element-179">
              <p className="text-lg text-gray-700" data-id="element-180">
                And you just smile... Because you know you did it from your
                kitchen. With your hands. With a new identity you chose to
                create.
              </p>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800" data-id="element-181">
            This is not a fantasy. It's what thousands of people are already
            experiencing.
          </p>
        </div>
      </div>
    </section>;
}